export default "__VITE_ASSET__BmGDqvX8__"